import { IconComponent } from './types';

const FencesIcon: IconComponent = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2.64024L0 2.64024L0 1.44024L12 1.44024V2.64024Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2 12H9V0L10.2 0V12Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.8 0L3 0V12H1.8V0Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 9.24023V10.4402H0V9.24023H12Z"
      fill="currentColor"
    />
  </svg>
);

export default FencesIcon;
